<div class="data-card-body">
  <div class="row">
    <div class="col-md col-lg-10">
      <h4 class="fs-18">We value your privacy</h4>
      <p class="fs-12">
        We use cookies to enhance your browsing experience. By clicking "Accept all" or by continuing to use this application, you consent to our use of cookies.
      </p>
    </div>
    <div class="col-md-3 col-lg-2">
      <div class="row">
        <div class="col-md-12">
          <button
            type="button"
            class="btn btn-primary d-block w-100 mb-1"
            (click)="setResponse(true)">
            Allow all
          </button>
        </div>
        <div class="col-md-12">
          <button type="button" class="btn btn-link d-block w-100 mb-1" (click)="openMoreOptions()">
            Cookie Policy
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
